const config = {
    api: {
        domain: 'http://localhost:8081',
        url: process.env.WDNA_API_URL || 'http://localhost:8081/api/v3',
        store: 'http://localhost:8080',
        headers: {
            'Content-Type': 'application/json',
        },
    },
    cdn: {
        endpoint: 'http://localhost:4572/salescdn.net',
    },
};

export default config;
